import React, { useState, useEffect, useMemo } from "react";
import "../Assests/Scss/Participation.scss";
import {
  AssessmentName, CAssessmentName
} from "../../Student/Reusablecomponents/RegularFunctions";
import Loading from "../../Student/Reusablecomponents/Loading";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import DropdownValues from "../../Student/Reusablecomponents/DropDownValues";
import { useNavigate } from "react-router-dom";
import { AllSubjectData } from "../../Redux/Reducers/HQAdmin/PerformanceOverallSubjects";
import { StateDetailsData } from "../../Redux/Reducers/HQAdmin/StatePerformanceDetails";
import { DistrictDetailsData } from "../../Redux/Reducers/HQAdmin/DistrictPerformanceDetails";
import DistricTrends from "./DistrictTrends";
import StateTrends from "./StateTrends";
import { Row, Col } from "react-bootstrap";
import SocietyLineTrends from "./SocietyLineTrends";
import { Testcolors } from "../../ReusableComponents/CommonFunctions";
import XLSX from "xlsx-js-style";
import { RiFileExcel2Fill } from "react-icons/ri";
const StatePerformanceDrillDown = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelecteRegionData = useSelector(
    (state) => state.SubjectsData.RegionDetails
  );
  const SelectStatedata = useSelector(
    (state) => state.StateDetails.StateDetails
  );
  const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);

  const Colors = ["#9acb64", "#435393", "#A03A13", "#d17373", "#FFDD94", "#FA897B", "#D0E6A5"];
  const [Load, SetLoad] = useState(false);

  const [NSData, SetNSData] = useState([]);
  const [RegionP, SetRegionP] = useState();
  const [StateWisedata, SetStateWisedata] = useState();
  const [RegionIds, SetRegionIds] = useState();

  const [DistrictWisedata, SetDistrictWisedata] = useState();
  const [StateIds, SetStateIds] = useState();
  const [DistrictIds, SetDistrictIds] = useState();

  const [Subjects, SetSubjects] = useState();
  const [SelectSUb, SetSelectSub] = useState();

  const [SelectRegionDetails, SetSelectRegionDetails] = useState({
    RegionName: SelecteRegionData?.[0]?.display || SelecteRegionData?.[0]?.Region,
    RegionId: SelecteRegionData?.[0]?.value || SelecteRegionData?.[0]?.Regionid || 0,
  });
  const [SelctStateDetails, SetSelctStateDetails] = useState({
    StateName: SelectStatedata?.[0]?.display,
    StateID: SelectStatedata?.[0]?.value,
  });
  // console.log("SelctStateDetails",SelctStateDetails);
  const NationalPerformance = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/InstitutionAdmin/GetNationalPerformance?ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}&InstituteId=${items?.instituteId}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].subjectName) {
          NationalRegionPerformance();
          SetNSData(res.data);
        } else {
          SetDistrictWisedata(process.env.REACT_APP_NODATAFOUND_Participated);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const NationalRegionPerformance = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/InstitutionAdmin/GetRegionPerformance?ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}&InstituteId=${items?.instituteId}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const regions = [...new Set(res.data.map((item) => item.region))];
        const regionIDs = Array.from(
          res.data
            .reduce(
              (map, item) =>
                map.set(item.region, {
                  display: item.region,
                  value: item.regionId,
                }),
              new Map()
            )
            .values()
        );
        SetRegionIds(regionIDs);
        const subjects = [...new Set(res.data.map((item) => item.subjectName))];
        const regionData = regions.map((region) => {
          const regionSubjects = res.data.filter(
            (item) => item.region === region
          );
          const subjectPercentages = subjects.reduce((acc, subject) => {
            acc[subject] =
              regionSubjects.find((item) => item.subjectName === subject)
                ?.percentage || "N/A";
            return acc;
          }, {});
          return { region, ...subjectPercentages };
        });
        SetRegionP(regionData);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const StatePerformance = async () => {
    SetLoad((prev) => !prev);

    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/InstitutionAdmin/GetStatePerformance?ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}&InstituteId=${items?.instituteId
        }&RegionId=${SelectRegionDetails?.RegionId || 0}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].state) {
          const regions = [...new Set(res.data.map((item) => item.state))];
          const regionIDs = Array.from(
            res.data
              .reduce(
                (map, item) =>
                  map.set(item.state, {
                    display: item.state,
                    value: item.stateId,
                  }),
                new Map()
              )
              .values()
          );
          SetStateIds(regionIDs);
          // console.log(SelecteRegionData,"-",SelectRegionDetails)
          if ((SelecteRegionData?.[0]?.value || SelecteRegionData?.[0]?.Regionid) !== SelectRegionDetails?.RegionId) {
            // console.log("if",regionIDs);
            SetSelctStateDetails({
              StateName: regionIDs?.[0].display,
              StateID: regionIDs[0].value,
            });
          } else {
            const SSD = regionIDs.filter(
              (item) => item.value === SelectStatedata?.[0]?.value
            );
            // console.log("SSD",SSD); 
            if (SSD?.length > 0) {
              SetSelctStateDetails({
                StateName: SelectStatedata?.[0].display,
                StateID: SelectStatedata?.[0].value,
              });
            } else {

              SetSelctStateDetails({
                StateName: regionIDs?.[0].display,
                StateID: regionIDs?.[0].value,
              });
            }
          }
          const subjects = [
            ...new Set(res.data.map((item) => item.subjectName)),
          ];
          const regionData = regions.map((state) => {
            const regionSubjects = res.data.filter(
              (item) => item.state === state
            );
            const subjectPercentages = subjects.reduce((acc, subject) => {
              acc[subject] =
                regionSubjects.find((item) => item.subjectName === subject)
                  ?.percentage || "N/A";
              return acc;
            }, {});
            return { state, ...subjectPercentages };
          });
          SetStateWisedata(regionData);
          if (items.userTypeId === 8) {
            const singlestate = [];
            res.data.map((item) => {
              if (item.state === res.data[0].state) {
                singlestate.push(item);
              }
            });
            SetNSData(singlestate);
          }
        } else {
          SetDistrictWisedata(process.env.REACT_APP_NODATAFOUND_Participated);
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const DistrictPerformance = async () => {
    SetDistrictIds();
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/InstitutionAdmin/GetDistrictPerformance?ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}&InstituteId=${items?.instituteId
        }&StateId=${SelctStateDetails?.StateID || StateIds?.[0]?.value}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].district) {
          const regions = [...new Set(res.data.map((item) => item.district))];
          const regionIDs = Array.from(
            res.data
              .reduce(
                (map, item) =>
                  map.set(item.district, {
                    display: item.district,
                    value: item.districtId,
                  }),
                new Map()
              )
              .values()
          );
          SetDistrictIds(regionIDs);
          const subjects = [
            ...new Set(res.data.map((item) => item.subjectName)),
          ];
          const regionData = regions.map((district) => {
            const regionSubjects = res.data.filter(
              (item) => item.district === district
            );
            const subjectPercentages = subjects.reduce((acc, subject) => {
              acc[subject] =
                regionSubjects.find((item) => item.subjectName === subject)
                  ?.percentage || "N/A";
              return acc;
            }, {});
            return { district, ...subjectPercentages };
          });
          SetDistrictWisedata(regionData);
        } else {
          SetDistrictWisedata(process.env.REACT_APP_NODATAFOUND_Participated);
        }
        SetLoad(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (SelectDate?.value > 0) {
      if (items.userTypeId !== 8) {
        NationalPerformance();
      } else {
        if (items?.societyId) {
          GetScoietyPercentage();
        } else {
          StatePerformance();
        }
      }
    }else{
     SetDistrictWisedata(process.env.REACT_APP_NODATAFOUND_Participated);
      SetRegionIds();
      SetStateIds();
      SetDistrictIds(); 
    }
  }, [SelectDate?.value]);

  const RenderStateDetails = (e) => {
    const value = RegionIds.filter(
      (item) => item.value === parseInt(e.target.value)
    );
    SetSelectRegionDetails({
      RegionName: value[0].display,
      RegionId: e.target.value,
    });
    dispatch(
      AllSubjectData({
        RegionDetails: [
          {
            display: value[0].display,
            value: e.target.value,
          },
        ],
      })
    );
  };
  const RenderDistrictDetails = (e) => {
    const value = StateIds?.filter((item) => item.value === parseInt(e));
    SetSelctStateDetails({
      StateName: value?.[0].display,
      StateID: e,
    });
  };
  useMemo(() => {
    if (SelectDate?.value > 0 && SelectRegionDetails?.RegionId) {
      StatePerformance();
    }
  }, [SelectRegionDetails, RegionP]);

  useMemo(() => {
    if (SelectDate?.value > 0 && SelctStateDetails?.StateID && !items?.societyId) {
      DistrictPerformance();
    }
  }, [SelctStateDetails]);

  const openSchoolDrilldown = (District) => {
    // localStorage.setItem("PerformanceDate", JSON.stringify(GetAssessmentdate));

    dispatch(
      AllSubjectData({
        RegionDetails: [
          {
            Region: SelectRegionDetails?.RegionName,
            Regionid: SelectRegionDetails?.RegionId,
          },
        ],
      })
    );

    dispatch(
      StateDetailsData({
        StateDetails: [
          {
            Region: SelctStateDetails?.StateName,
            Regionid: SelctStateDetails?.StateID,
          },
        ],
      })
    );

    const Dvalue = DistrictIds.filter((item) => item.display === District);
    dispatch(DistrictDetailsData({ DistrictDetails: Dvalue }));
    navigate(
      `/InstitutionAdmin/Performance/RegionPerformanceDetails/StatePerformanceDetails/DistrictPerformanceDetails`
    );
  };

  // Below is Scoiety releated

  const GetScoietyPercentage = async () => {
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/InstitutionAdmin/GetSocietyWisePerformance?ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}&InstituteId=${items?.instituteId}&SocietyId=${items?.societyId}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].subjectName) {
          SetNSData(res.data);
          ScoietyDistrictPerformance();
        } else {
          SetDistrictWisedata(process.env.REACT_APP_NODATAFOUND_Participated);
          SetLoad((prev) => !prev);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const ScoietyDistrictPerformance = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/InstitutionAdmin/GetSocietyWiseDistrictPerformance?ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}&InstituteId=${items?.instituteId}&SocietyId=${items?.societyId}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].district) {
          const regionIDs = Array.from(
            res.data
              .reduce(
                (map, item) =>
                  map.set(item.district, {
                    display: item.district,
                    value: item.districtId,
                  }),
                new Map()
              )
              .values()
          );
          SetDistrictIds(regionIDs);

          const formattedData = res.data.reduce((acc, curr) => {
            const { district, subjectName, percentage } = curr;
            if (!acc[district]) {
              acc[district] = { district };
            }
            acc[district][subjectName] = percentage;
            return acc;
          }, {});

          const finalArray = Object.values(formattedData);

          SetDistrictWisedata(finalArray);
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useMemo(() => {
    //  dispatch(
    //       AllSubjectData({
    //         RegionDetails: [
    //           {
    //             Region: SelectRegionDetails?.RegionName,
    //             Regionid: SelectRegionDetails?.RegionId,
    //           },
    //         ],
    //       })
    //     );
    // dispatch(StateDetailsData({
    //   StateDetails: [
    //     { display: SelctStateDetails?.StateName || SelctStateDetails?.[0]?.display, value: SelctStateDetails?.StateID || SelctStateDetails?.[0]?.value },],
    // }));
  }, [SelectRegionDetails, SelctStateDetails]);
  //  4th May 2026 Export the table data in Excel Format
   const exportToExcel = () => {
      const table = document.getElementById("performanceTable");
  
      if (!table) {
        alert("Table not found!");
        return;
      }
  
      const worksheet = XLSX.utils.table_to_sheet(table, { raw: true });
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
  
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
  
          if (!worksheet[cellAddress]) continue;
  
          worksheet[cellAddress].s = {
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
  
      if (worksheet["A1"]) {
        worksheet["A1"].s = {
          ...worksheet["A1"].s,
          font: {
            bold: true,
          },
          alignment: {
            horizontal: "center",
            vertical: "center",
          },
        };
      }
      const SecondRow = items.userTypeId !== 8 ? "A6" : "A4"
      if (worksheet[SecondRow]) {
        worksheet[SecondRow].s = {
          ...worksheet[SecondRow].s,
          font: {
            bold: true,
          },
        };
      }
  
      for (let C = range.s.c; C <= range.e.c; C++) {
    const cellAddress = XLSX.utils.encode_cell({
      r: 1,
      c: C,
    });
  
    if (!worksheet[cellAddress]) continue;
  
    worksheet[cellAddress].s = {
      ...worksheet[cellAddress].s,
      font: {
        ...(worksheet[cellAddress].s?.font || {}),
        bold: true,
      },
      alignment: {
        horizontal: "center",
        vertical: "center",
      },
    };
  }
  const FileName = items?.societyId ? "Society" : "State";
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, `${FileName} Performance`);
  
       
      XLSX.writeFile(workbook, `${FileName} Performance ${SelectDate?.assessmentTypeName}_${SelectDate?.examStartDate}.xlsx`);
    };
  return (
    <>
      <div className="TeacherBgImage">
        <InternetChecking />
        <div className="dflex JSBetween alignitems">
      <div></div>
        <div className="MainHeading">
          {SelctStateDetails.StateName} {items?.societyId ? "Society" : "State"}   Performance in {CAssessmentName(SelectDate?.assessmentType)} - {SelectDate?.examStartDate}
        </div>
        {/*   4th May 2026 Trigger the export excel function */}
             <div className="ExportExcel" onClick={() => exportToExcel()}>{DistrictWisedata?.[0]?.district &&  <RiFileExcel2Fill />} </div>
       </div>
        <div className="dflex JSBetween mt-1">
          <div></div>
         {items?.userTypeId === 10 && (
            <b><span >{SelectRegionDetails?.RegionName ? <><span className="CPointer text-decoration-underline" onClick={() => navigate(-2)} style={{ color: "#696969" }}>National</span>{""} &gt; {""}<span className="CPointer text-decoration-underline" onClick={() => navigate(-1)} style={{ color: "#696969" }}>{SelectRegionDetails?.RegionName}</span>{""} &gt; {""}</> : ""}</span> <span style={{ color: "#00009A" }}>{SelctStateDetails?.StateName ? `${SelctStateDetails?.StateName} ` : ""}</span></b>)}
          <div></div>

</div>
        <div className="dflex JSBetween mb-2 ">
          {/* <div></div> */}


          {items?.societyId ? (
            <div className="SubHeading">
              <b>Society : </b> {items?.societyName}
            </div>
          ) : (
            <div></div>
          )}
         
          <div className="dflex gap-3">
            {RegionIds && (<div className="dflex gap-2">
              <div className="DropdownHeader">Region: </div>
              <DropdownValues
                className="NCLDropdown"
                options={RegionIds}
                onChange={(e) => RenderStateDetails(e)}
                selectoption={SelectRegionDetails?.RegionId}
              /></div>
            )}
            {(items?.instituteId === 2 || items?.instituteId === 4 || items?.instituteId === 7) ? ""
              : StateIds && (<div className="dflex gap-2">
                <div className="DropdownHeader">State: </div>
                {StateIds?.length === 1 ? <input type="text" className="NCLDropdown" value={SelctStateDetails.StateName} /> :
                  <DropdownValues
                    className="NCLDropdown"
                    options={StateIds}
                    onChange={(e) => RenderDistrictDetails(e.target.value)}
                    selectoption={SelctStateDetails.StateID}
                  />}</div>
              )}

          </div>
        </div>
        <div className="Table-Card">
          {DistrictWisedata?.[0]?.district ? (
            <table className="w-100 Inst_Performance-Table" id="performanceTable">
              <thead>
                <tr>
                  {/* {SelctStateDetails.StateName}{" "}
                    {items?.societyId ? "Society" : "State"} */}
                  <th colSpan={NSData?.length + 1}>
                    Performance report
                  </th>
                </tr>
                <tr>
                  <th></th>
                  {NSData?.map((item, index) => (
                    <th key={index}>{item.subjectName}(%)</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {/* {items.userTypeId !== 8 && (
                  <tr>
                    <th style={{ color: "#205680" }}> {items.userTypeId !== 8 ? "National" : "State"}
                    </th> items?.societyId {NSData?.map((item, index) => ( <td key={index}>{item.percentage}%</td> ))}
                  </tr>
                )} */}
                {(items.userTypeId !== 8 || items?.societyId !== 0) && (
                  // <tr style={{ color: "#205680" }}>
                  <tr style={{ color: "#7030a0" }}>
                    <th className={` ft-18 ${items?.societyId === 0 ? "CPointer text-decoration-underline" : ""}`} onClick={() => { items.userTypeId !== 8 && navigate(-2) }} >
                      {/* <th className={`${items}`}"ft-18 CPointer text-decoration-underline" onClick={()=>{items.userTypeId !== 8 &&navigate(-2)}} > */}
                      {items.userTypeId !== 8 ? "National" : items?.societyId ? NSData?.[0]?.society : "State"}
                    </th>
                    {NSData?.map((item, index) => (
                      <td key={index}>{item.percentage}%</td>
                    ))}
                  </tr>
                )}
                {((items?.instituteId !== 8 || items?.instituteId !== 9) && !items?.societyId) &&
                  (items.userTypeId !== 8
                    ? [
                      { level: "region", data: RegionP, key: SelectRegionDetails?.RegionName, Colour: "#008080", Click: () => navigate(-1), },
                      { level: "state", data: StateWisedata, key: SelctStateDetails?.StateName, Colour: "#435393" },
                    ]
                    : [
                      {
                        level: "state", data: StateWisedata, key: SelctStateDetails?.StateName,
                        Colour: "#435393"
                      },
                    ]
                  ).map(({ level, data, key, Colour, Click }, levelIndex) => (
                    <tr key={levelIndex} style={{ color: Colour }}>
                      {/* <tr key={levelIndex} style={{ color: Colors[levelIndex] }}> */}
                      <th className={`${Click ? "CPointer text-decoration-underline" : ""}`} onClick={Click}> {key} </th>
                      {data?.map(
                        (item) =>
                          item[level] === key &&
                          NSData?.map((subject, index) => (
                            <td key={index}>
                              {item[subject.subjectName] === "N/A" ||
                                item[subject.subjectName] === undefined
                                ? "-"
                                : item[subject.subjectName] + "%"}
                            </td>
                          ))
                      )}
                    </tr>
                  ))}
                <tr>
                  <th
                    colSpan={NSData?.length + 1}
                    style={{ textAlign: "justify" }}
                  >
                    {SelctStateDetails.StateName}{" "}
                    {items?.societyId ? "Society" : "State"} - Districts
                    Performance
                  </th>
                </tr>
                {DistrictWisedata?.map((item, index) => (
                  <tr key={index}>
                    <th
                      className="text-decoration-underline CPointer"
                      onClick={() => openSchoolDrilldown(item.district)}
                      // style={{ color: "#259957" }}
                      style={{ color: Colors[2] }}
                    >
                      {item.district}
                    </th>
                    {NSData?.map((Subject, index) => (
                      <td key={index}>
                        {item[Subject.subjectName] === "N/A" ||
                          item[Subject.subjectName] === undefined
                          ? "-"
                          : item[Subject.subjectName] + "%"}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="ErrorMessage">{DistrictWisedata}</div>
          )}
        </div>

        <div className="SubHeading mt-3">
          {items?.societyId ? "Society" : "State"} vs District performance
          trends
        </div>
        <div className="container-fluid">
          <Row className=" Card mt-3 dflex" style={{ gap: "10px" }}>
            <div className="dflex RegionSub-Navigations">
              {Subjects?.map((item, index) => (
                <span
                  key={index}
                  onClick={() => {
                    SetSelectSub(item);
                  }}
                  style={
                    SelectSUb !== item
                      ? { color: "#878997", backgroundColor: "#f5f5f5" }
                      : {}
                  }
                >
                  {item}
                </span>
              ))}
            </div>
            <Col style={{ borderRight: "1px solid #CBCBCB" }}>
              {items?.societyId ? (
                <SocietyLineTrends
                  AType={SelectDate?.assessmentType}
                  SubSelect={SelectSUb}
                  SelectedState={SelctStateDetails}
                  StateIds={StateIds}
                  StoreSubjects={SetSubjects}
                  StoreSelSub={SetSelectSub}
                />
              ) : (
                <StateTrends
                  AType={SelectDate?.assessmentType}
                  SubSelect={SelectSUb}
                  SelectedState={SelctStateDetails}
                  StateIds={StateIds}
                  StoreSubjects={SetSubjects}
                  StoreSelSub={SetSelectSub}
                />
              )}
            </Col>
            <Col>
              {DistrictIds && (
                <DistricTrends
                  AType={SelectDate?.assessmentType}
                  SubSelect={SelectSUb}
                  SelectedState={SelctStateDetails}
                  DistrictIds={DistrictIds}
                />
              )}{" "}
            </Col>
          </Row>
        </div>
        {/* <CopyRight /> */}
      </div>
      {Load && <Loading />}
    </>
  );
};
export default StatePerformanceDrillDown;
